/* eslint-disable no-magic-numbers */
import { useState } from 'react'

export const usePagination = (state) => {
  const [pagination, setPagination] = useState(state)

  function selectPage(currentPage) {
    setPagination((s) => {
      return { ...s, currentPage }
    })
  }

  function nextPage() {
    if (pagination.currentPage === pagination.totalPages) {
      return
    }
    setPagination((s) => {
      return { ...s, currentPage: s.currentPage + 1 }
    })
  }

  function prevPage() {
    if (pagination.currentPage === 1) {
      return
    }
    setPagination((s) => {
      return { ...s, currentPage: s.currentPage - 1 }
    })
  }

  function nextSection() {
    if (pagination.currentPage < 4) {
      setPagination((s) => {
        return { ...s, currentPage: 6 }
      })
      return
    }
    setPagination((s) => {
      return { ...s, currentPage: s.currentPage + 2 }
    })
  }

  function prevSection() {
    if (pagination.currentPage > pagination.totalPages - 4) {
      setPagination((s) => {
        return { ...s, currentPage: s.totalPages - 5 }
      })
      return
    }
    setPagination((s) => {
      return { ...s, currentPage: s.currentPage - 2 }
    })
  }

  const changeResultsPerPage = (e) => {
    setPagination((s) => {
      return { ...s, resultsPerPage: e.value, currentPage: 1 }
    })
  }

  return {pagination, setPagination, selectPage, nextPage, prevPage, nextSection, prevSection, changeResultsPerPage}
}
